export enum EDashboardTab {
  UW = 'uw-dashboard',
  FINANCE = 'finance-dashboard',
  CLAIM = 'claim-dashboard',
}
